import { render, staticRenderFns } from "./skdzd.vue?vue&type=template&id=757ba50f&scoped=true&"
import script from "./skdzd.vue?vue&type=script&lang=js&"
export * from "./skdzd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757ba50f",
  null
  
)

export default component.exports